import { Component } from '@angular/core';
import { SettingsActivitiesProgOption } from 'src/app/enums/settings';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-settings-activities-prog',
    templateUrl: './settings-activities-prog.component.html',
    styleUrls: ['./settings-activities-prog.component.scss']
})
export class SettingsActivitiesProgComponent {
    readonly SettingsActivitiesProgOption = SettingsActivitiesProgOption;
    selectedComponent!: SettingsActivitiesProgOption;

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        // if (!this.permissionsService.hasPermission('dgaspc.settings.document_statuses.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesProgOption.DOCUMENT_STATUSES
        //     );
        // }
    }

    componentMapping: Record<SettingsActivitiesProgOption, string> = {
        [SettingsActivitiesProgOption.MODULE]: 'app-modul',
        [SettingsActivitiesProgOption.LOCATII]: 'app-locatii',
        [SettingsActivitiesProgOption.ZILE_LIBERE]: 'app-zile-libere',
        [SettingsActivitiesProgOption.SPECIALIZARI]: 'app-specializari',
        [SettingsActivitiesProgOption.STATUSURI]: 'app-status',
        [SettingsActivitiesProgOption.PRIORITATI]: 'app-prioritati',
        [SettingsActivitiesProgOption.OPERATORI]: 'app-operatori',
        [SettingsActivitiesProgOption.TIPURI_PROBLEME]: 'app-tipuri-probleme',
        [SettingsActivitiesProgOption.PROGRAM]: 'app-program',
    };

    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;
}
